// import { useMutation } from "@tanstack/react-query";
import {
  createContext,
  useState,
  ReactNode,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";
import { apiLogin } from "../services/api";
import { useCookies } from "react-cookie";
import jwt_decoded from "jwt-decode";
import { useMutation } from "@tanstack/react-query";

interface LoginProps {
  login: string;
  password: string
}

interface AuthContextProviderProps {
  children: ReactNode;
}

interface AuthContextProps {
  isAuthenticated: boolean;
  error: string;
  onLogout: () => void;
  validToken(token?: string): void
  decodedToken(): any;
  Login: ({ login, password }: LoginProps) => Promise<string>
  cookies?: {
    user?: any;
    token?: string;
    whatsapp?: {
      queueId: string,
      token: string
    }
  }
}

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

export const AuthProvider = ({ children }: AuthContextProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies(['token', 'user', 'whatsapp'])
  const [error, setError] = useState('')

  const mutateLogin = useMutation({ mutationKey: ['login'], mutationFn: ({ login, password }: LoginProps) => apiLogin.post('/login', { login, password, modulo: 1 }), onError: () => setError('Usuário ou senha incorretos'), onSuccess: () => setError('') })

  //Mudar para backend
  function validToken(token?: string) {
    if (token) {
      const decoded = jwt_decoded(token) as any
      const now = new Date().getTime() / 1000;
      if (now > decoded?.exp) {
        removeCookies('token')
        removeCookies('user')
        removeCookies('whatsapp')
        setIsAuthenticated(false);
        navigate('/')
      } else {
        setIsAuthenticated(true);
      }
    }
  }
  function decodedToken() {
    const decoded = jwt_decoded(cookies.token) as any
    return decoded
  }




  async function Login({ login, password }: LoginProps) {
    const { data } = await mutateLogin.mutateAsync({ login, password })
    if (data && data.token) {
      setCookies('token', data.token)
      setIsAuthenticated(true);
      return "/home";
    }
    return ''
  }

  function onLogout() {
    removeCookies('token')
    removeCookies('user')
    removeCookies('whatsapp')
    setIsAuthenticated(false);
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, onLogout, Login, cookies, validToken, decodedToken, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
